import React, { useState } from 'react';
import Button from 'web/components/Button';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { MyBidsMobileViewWrapper } from '../myPostStyled'
import CurrencyFormat from 'react-currency-format';
import DownArrow from 'web/assets/svg/AccordionDownArrow'
import UpArrow from 'web/assets/svg/AccordionUpArrow'

const MobileViewAccordion = (props) => {
    const { currentPageNumber, items, timeFormat, declineBidFunction, pageLanguageContents, bidPriceTootTip } = props
    const dispatch = useDispatch();
    const history = useHistory();
    const [isOpen, setIsOpen] = useState([]);

    const toggleAccordion = (index) => {
        const newIsOpen = [...isOpen];
        newIsOpen[index] = !newIsOpen[index];
        setIsOpen(newIsOpen);
    };

    function capitalizeFirstLetter(str) {
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }

    return (
        <MyBidsMobileViewWrapper>
            {items?.map((item, index) => (
                <div key={index} className={`mobile-bid-accordion ${isOpen[index] ? 'open' : ''}`}>
                    <div className="accordion-header" onClick={() => toggleAccordion(index)}>
                        <div className="accordion-header-left">
                            <div className="bid-info">
                                <h6>Company</h6>
                                <p>{item.bidderLocationInfo}</p>
                            </div>
                            <div className="bid-info">
                                <h6>Bid Price{bidPriceTootTip()}</h6>
                                <p><CurrencyFormat value={item?.bidPrice?.toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={'$'} /></p>
                            </div>
                        </div>
                        <div className="accordion-header-right">
                            <p>{isOpen[index] ? <UpArrow /> : <DownArrow />}</p>
                        </div>
                    </div>
                    {isOpen[index] && (
                        <div className="accordion-content">
                            <div className="accordion-column">
                                <div className="bid-info-header">
                                    <div className="bid-info">
                                        <h6>Date</h6>
                                        <p>{item.requestedDelDate}</p>
                                    </div>
                                    <div className="bid-info">
                                        <h6>Time</h6>
                                        <p>{timeFormat(item.appointmentStartTime)} - {timeFormat(item.appointmentEndTime)}</p>
                                    </div>
                                </div>
                                <div className="bid-info-header">
                                    <div className="bid-info">
                                        <h6>Qty</h6>
                                        <p>{item.qty && <CurrencyFormat value={item.qty} displayType={'text'} prefix={''} />}</p>
                                    </div>
                                    <div className="bid-info">
                                        <h6>Bid Status</h6>
                                        <p>{item.bidStatus}</p>
                                    </div>
                                </div>
                                <div className="bid-info-header">
                                    <div className="bid-info">
                                        <h6>Mode</h6>
                                        <p>{capitalizeFirstLetter(item.shippingMode)}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-buttons">
                                {(item.bidStatus?.includes('Accepted') || item.bidStatus?.includes('Received')) && (
                                    <Button type='app-green-button' handleClick={() => {
                                        let obj = {
                                            id: item.bidId?.toString(),
                                            type: 'buyerNeedCheckout'
                                        }
                                        dispatch({ type: 'CHECKOUT', payload: obj })
                                        let obj2 = { selectedPage: currentPageNumber };
                                        dispatch({ type: "BIDS_PAGINATION", payload: obj2 });
                                        history.push({ pathname: '/checkout' });
                                    }}>
                                        {pageLanguageContents?.Contents[28]?.View}
                                    </Button>
                                )}
                                {item.bidStatus?.toLowerCase()?.includes('received') && (
                                    <Button type='app-green-button' handleClick={() => declineBidFunction(item.bidId)} >
                                        Decline
                                    </Button>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            ))}
        </MyBidsMobileViewWrapper>
    );
};

export default MobileViewAccordion;
